__turbopack_context__.v({
  "className": "e_L4PG_className",
  "variable": "e_L4PG_variable",
});
